import React, {useEffect, useState} from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ListGroup from "react-bootstrap/ListGroup";
import {Link} from "react-router-dom";
import PlayerFetch from "../PlayerFetch";
import Collapse from "react-bootstrap/Collapse";
import {useGlobal} from 'reactn';
import {FaVolumeUp} from "react-icons/fa";
import Spinner from "react-bootstrap/Spinner";

function AdvancedSearch() {

    const [data, setData] = useState({results: []});
    const [page, setPage] = useState(1);
    const [query, setQuery] = useGlobal([]);
    const [query1, setQuery1] = useState(query);

    const [type, setType] = useState('wav')
    const [channels, setChannels] = useState('2')
    const [tag, setTag] = useState("")
    const [description, setDescription] = useState("")
    const [duration, setDuration] = useState(0);

    const [url, setUrl] = useState(
        'https://freesound.org/apiv2/search/text/?page_size=7&query=' + query1 + '&token=' + global.KEY);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);

            try {
                const result = await axios(url);

                setData(result.data);
            } catch (error) {
                setIsError(true);
            }

            setIsLoading(false);
        };
        fetchData();
    }, [url]);

    // add tag value to url if not null
    function isTag(tag) {
        if (tag === "") {
            return '';
        } else {
            return '%20tag:' + tag;
        }
    }

    // add description value to url if not null
    function isDescription(description) {
        if (description === "") {
            return '';
        } else {
            return '%20description:' + description;
        }
    }

    return (
        <div className="Search">
            <Form className="form-inline my-2 my-lg-0">
                <Form.Control className="form-control mr-sm-2" type="text" placeholder="" value={query1}
                              aria-label="Search" onChange={event => setQuery1(event.target.value)}/>

                <Button type="button" onClick={() => {
                    setUrl(prevState => 'https://freesound.org/apiv2/search/text/?page_size=7&query='
                        + query1 +
                        '&filter=type:' + type +
                        '%20channels:' + channels +
                        isTag(tag) +
                        isDescription(description) +
                        '&page_size=7&token=' + global.KEY)
                    setQuery1(query)
                    setQuery1(query1)
                    setQuery(null)
                }

                }
                >
                    Search
                </Button>
            </Form>

            <div className="mb-3 mt-3 alert alert-info">
                <Button
                    className="btn btn-light"
                    variant="outline-info"
                    onClick={() => setOpen(!open)}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                >
                    advanced search
                </Button>
                <Collapse in={open}>
                    <div id="example-collapse-text" className="mt-3">
                        <Form>
                            <Form.Group>
                                <Form.Label><small>Channels </small><small className="text-muted">
                                    <em>(Number of channels in sound, mostly 1(mono) or 2 (stereo).)
                                    </em>></small></Form.Label>
                                <Form.Control as="select" value={channels}
                                              onChange={event => setChannels(event.target.value)}>
                                    <option>2</option>
                                    <option>1</option>
                                </Form.Control>
                                <hr/>
                                <Form.Label><small>Type </small><small className="text-muted">
                                    <em>(Original file type, one off [“wav”, “aiff”, “ogg”, “mp3”, “m4a”, “flac”].)
                                    </em>></small></Form.Label>
                                <Form.Control as="select" value={type} onChange={event => setType(event.target.value)}>
                                    <option>wav</option>
                                    <option>aiff</option>
                                    <option>ogg</option>
                                    <option>mp3</option>
                                    <option>m4a</option>
                                    <option>flac</option>
                                </Form.Control>
                                <hr/>
                                <Form.Label><small>Tags </small><small className="text-muted">
                                    <em>(insert tags)</em></small></Form.Label>
                                <Form.Control className="form-control mr-sm-2" type="text" placeholder="" value={tag}
                                              aria-label="" onChange={event => setTag(event.target.value)}>
                                </Form.Control>
                                <hr/>
                                <Form.Label><small>Description </small><small className="text-muted">
                                    <em>(insert description)</em></small></Form.Label>
                                <Form.Control className="form-control mr-sm-2" type="text" placeholder=""
                                              value={description}
                                              aria-label="" onChange={event => setDescription(event.target.value)}>
                                </Form.Control>
                                <hr/>
                                <Form.Label>
                                    <small>Duration </small>
                                    <small className="text-muted">
                                        <em>(Duration of file.)
                                        </em>
                                    </small>
                                </Form.Label>
                                <Form.Control type="range" className="custom-range" id="tempo"
                                              min="0" max="300" step="1"
                                              value={duration}
                                              onChange={event => setDuration(event.target.value)}
                                />
                                {duration}
                                <hr/>
                                <Button type="button" onClick={() => {
                                    setUrl(prevState => 'https://freesound.org/apiv2/search/text/?page_size=7&query='
                                        + query1 +
                                        '&filter=type:' + type +
                                        '%20channels:' + channels +
                                        isTag(tag) +
                                        isDescription(description) +
                                        '&page_size=7&token=' + global.KEY)
                                    setQuery1(query)
                                    setQuery1(query1)
                                    setQuery(query1)
                                }

                                }
                                >
                                    Search
                                </Button>
                            </Form.Group>
                        </Form>
                    </div>
                </Collapse>
            </div>


            {isError && <div className="alert-danger mb-3">Something went wrong ...</div>}

            {isLoading ? (
                <div><Spinner animation="border"/> Loading ...</div>
            ) : (
                <div>
                    <ListGroup>
                        {data.results.map(item => (
                            <ListGroup.Item key={item.id}>
                                <Link to={`/sound/${item.id}`}><h4><span
                                    className="align-text-top"><FaVolumeUp/></span> {item.name}</h4>
                                    <p><PlayerFetch id={item.id}/></p>
                                </Link>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
            )}

            <div className="container mb-5 mt-5">
                <div className="row justify-content-center">
                    <Button variant="secondary"
                            onClick={() => {
                                setPage(prevState => page + 1)
                                setUrl(prevState => 'https://freesound.org/apiv2/search/text/?page_size=7&query='
                                    + query1 +
                                    '&filter=type:' + type +
                                    '%20channels:' + channels +
                                    isTag(tag) +
                                    isDescription(description) +
                                    '&page=' + page +
                                    '&page_size=7&token=' + global.KEY)
                            }}>
                        Load more</Button>
                </div>
            </div>
        </div>
    );
}

export default AdvancedSearch;